import React from 'react';
import WishListContainer from '../../../Componant/Ecommerce/WishList';

const WishList = () => {
  return (
    <div className='page-body'>
      <WishListContainer />
    </div>
  );
};

export default WishList;
